export enum WebsocketEvent {
  REFRESH_JOURNAL = 'REFRESH_JOURNAL',
  INVOICE_PROCESSING_CHANGE_STATUS = 'INVOICE_PROCESSING_CHANGE_STATUS',
  INVOICE_ACCOUNTING_PROCESSING_CHANGE_STATUS = 'INVOICE_ACCOUNTING_PROCESSING_CHANGE_STATUS',
}

export type WebSocketResponse<T> = T & { event: WebsocketEvent };

export type WebSocketTypedResponse =
  WebSocketResponse<CargoProcessStatusChange | null>;

export type CargoProcessStatusChange = {
  processingId: number;
};
